/** @jsx jsx */
import { ClassNames, jsx } from "@emotion/core";
import React from "react";
import env from "../../../../env";
import { usePost, Button, ErrorMessage } from "../../../../components";
import { useForm } from "../../../../form";
import cmsUtils from "cms/utils/cmsUtils";
import utils from "utils";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";

import { shouldHidePopupForms } from "../../../utils/cmsDetection";
import { SiteLink } from 'components';

function Portal({ children }) {
  const [el] = useState(document.createElement("div"));
  useEffect(() => {
    let mount = document.getElementById("portal-root");
    mount.appendChild(el);
    return () => mount.removeChild(el);
  }, [el]);
  return createPortal(children, el);
}

export function PopupForm(props) {
  const item = props.item;
  const isMobile = utils.site.isMobile();

  const Title = cmsUtils.payload(item, "Title");
  const Description = cmsUtils.payload(item, "Description");
  const popupFormStatus = cmsUtils.payload(item, "PopupForm");
  const ImageUrl = cmsUtils.payload(item, "ImageUrl");
  const LinkUrl = cmsUtils.payload(item, "LinkUrl");
  const Date = cmsUtils.payload(item, "Date");
  const ExpiryTime = cmsUtils.payload(item, "ExpiryTime");
  const ButtonColour = cmsUtils.payload(item, "ButtonColour");
  const ButtonText = cmsUtils.payload(item, "ButtonText");

  const isExpired = (() => {
    if (!ExpiryTime) return false;
    const parts = ExpiryTime.split("/");
    if (parts.length !== 3) return false;
    const expiry = new window.Date(parts[2], parts[1] - 1, parts[0], 23, 59, 59);
    return new window.Date() > expiry;
  })();

  const [modalOpen, setModalOpen] = useState(false);
  const [mobileModalOpen, setMobileModalOpen] = useState(false);
  const [mobileSecondModalOpen, setMobileSecondModalOpen] = useState(false);
  const [thankyouModalOpen, setThankyouModalOpen] = useState(false);

  useEffect(() => {
    if (isExpired) return;
    if (popupFormStatus === "Hide")
      if (shouldHidePopupForms()) {
        return;
      }

    const timer = setTimeout(() => {
      const dontShow = localStorage.getItem("donot");
      if (dontShow === "true") {
        setMobileModalOpen(false);
      } else {
        setMobileModalOpen(true);
      }
    }, 20000);
    return () => clearTimeout(timer);
  }, [popupFormStatus, isExpired]);

  useEffect(() => {
    if (isExpired) return;
    if (popupFormStatus === "Hide")
      if (shouldHidePopupForms()) {
        return;
      }

    const timer = setTimeout(() => {
      const dontShow = localStorage.getItem("donot");
      if (dontShow === "true") {
        setModalOpen(false);
      } else {
        setModalOpen(true);
      }
    }, 5000);
    return () => clearTimeout(timer);
  }, [popupFormStatus, isExpired]);

  useEffect(() => {
    if (thankyouModalOpen === true) {
      const timer = setTimeout(() => {
        setThankyouModalOpen(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [thankyouModalOpen]);

  const doNotShow = () => {
    localStorage.setItem("donot", JSON.stringify(true));
    setModalOpen(false);
    setMobileModalOpen(false);
    setMobileSecondModalOpen(false);
  };

  // Function to reset the "don't show again" preference
  // Call this function to allow the popup to show again
  const resetDontShow = () => {
    localStorage.removeItem("donot");
    // You can also use: localStorage.setItem("donot", "false");
  };

  if (isExpired) return null;

  // Don't render any popup forms if in CMS editing mode
  if (popupFormStatus === "Hide")
    if (shouldHidePopupForms()) {
      return <div></div>;
    }

  const isVisible = isMobile ? mobileModalOpen : modalOpen;

  const closePopup = () => {
    setModalOpen(false);
    setMobileModalOpen(false);
  };

  if (!isVisible) return null;

  return (
    <Portal data-cms-item-id={props.cmsOption.isCmsEdit && props.item.itemId} id={props.item.anchorName}>
      <div className="popup-form-background" onClick={closePopup}>
        <div className="popup-form-container" style={{ backgroundImage: utils.css.bgUrlStyle(ImageUrl) }} onClick={(e) => e.stopPropagation()}>
          <button className="popup-form-close" onClick={closePopup} aria-label="Close">
            &times;
          </button>
          <div className="popup-form-content">
            <div className="popup-form-date">{Date}</div>
            <div className="popup-form-title">{Title}</div>
            <div className="popup-form-description">{Description}</div>
            <SiteLink to={LinkUrl} target="_blank" rel="noopener noreferrer">
              <Button style={{ backgroundColor: ButtonColour, borderColor: ButtonColour }}>{ButtonText}</Button>
            </SiteLink>
          </div>
        </div>
      </div>
    </Portal>
  );
}
